import { Component, inject, signal } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { firstValueFrom } from 'rxjs';
import { SNACKBAR_DURATION_ERROR } from '../../app.constants';
import { AdminGroup, AdminGroupsService } from '../admin-groups.service';

@Component({
	selector: 'app-admin-groups',
	imports: [MatProgressSpinnerModule],
	templateUrl: './admin-groups.component.html',
})
export class AdminGroupsComponent {
	private readonly groupsService = inject(AdminGroupsService);
	private readonly snackBar = inject(MatSnackBar);

	groups = signal<AdminGroup[]>([]);
	groupsLoaded = signal(false);

	constructor() {
		this.loadGroups();
	}

	private async loadGroups() {
		try {
			const groups = await firstValueFrom(this.groupsService.getGroups());
			this.groups.set(groups);
		} catch {
			this.snackBar.open(
				$localize`:@@FailedToLoadGroups:Failed to load groups`,
				undefined,
				{ duration: SNACKBAR_DURATION_ERROR }
			);
		} finally {
			this.groupsLoaded.set(true);
		}
	}
}
